export const HIDDEN_TIPS = 'hidden-tips';
